export type NicknameValidation =
  { valid: true; nickname: string } | { valid: false; message: string };

const nicknamePattern = /^[\p{L}\p{N}_\- ]+$/u;

export const validateNickname = (input: string): NicknameValidation => {
  const nickname = input.trim().replace(/\s+/g, ' ');
  const length = Array.from(nickname).length;
  if (length < 2) return { valid: false, message: 'Nickname must contain at least 2 characters' };
  if (length > 16) return { valid: false, message: 'Nickname must contain at most 16 characters' };
  if (!nicknamePattern.test(nickname))
    return {
      valid: false,
      message: 'Nickname can contain letters, numbers, spaces, _ and - only',
    };
  return { valid: true, nickname };
};
